import React from 'react'
import { InfoWrap, PageInfo } from '../PageInfo'

export function FeaturedInfo() {
  return (
    <InfoWrap>
      <PageInfo heading="Featured communities" text="Weekly Featured Communities" />
    </InfoWrap>
  )
}
